export default {
    accessToken: '08463d0efa9e432a9889a928387ceee3',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        environment: process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development',
        code_version: process.env.VUE_APP_VERSION || 'unknown',
    }
};